var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageditservice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 22 Copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 27",
    opacity: 0.195126,
    width: 70,
    height: 70,
    rx: 24,
    fill: "#79DFE9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4339 18.4538C34.9249 17.6775 35.8726 17.3229 36.7527 17.5861C37.6246 17.8511 38.2181 18.6583 38.2111 19.5695V30.6241H46.9614C47.4943 30.625 47.9842 30.9164 48.2393 31.3842C48.4945 31.8519 48.4742 32.4216 48.1865 32.87L36.1548 51.5448C35.7812 52.1391 35.1285 52.4998 34.4266 52.5C34.2265 52.499 34.0277 52.4696 33.8359 52.4125C32.964 52.1475 32.3705 51.3403 32.3775 50.4291V39.3745H23.6272C23.092 39.3753 22.5993 39.0829 22.3436 38.6127C22.088 38.1425 22.1104 37.57 22.4021 37.1213L34.4339 18.4538ZM35.2943 47.5344L44.2926 33.5411H36.7527C35.9473 33.5411 35.2943 32.8881 35.2943 32.0827V22.4646L26.296 36.4579H33.8359C34.6414 36.4579 35.2943 37.1108 35.2943 37.9163V47.5344Z",
    fill: "#42B6C1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageditservice);
export default __webpack_public_path__ + "static/media/manageditservice.cb4e80f4c55dbcaa4af71e5f2719c8bc.svg";
export { ForwardRef as ReactComponent };